import { startOfYear, subYears } from "date-fns";

export type RequiredDateRange = {
  startDate: Date;
  endDate: Date;
};

/**
 * Default range used across dashboards: Jan 1 of the previous year through today.
 *
 * Examples:
 * - Jan 5, 2026 => Jan 1, 2025 .. Jan 5, 2026
 * - Dec 8, 2026 => Jan 1, 2025 .. Dec 8, 2026
 */
export function getLastYearToDateRange(
  today: Date = new Date()
): RequiredDateRange {
  const endDate = today;
  const startDate = startOfYear(subYears(endDate, 1));
  return { startDate, endDate };
}

export function getLastYearToDateIsoRange(today: Date = new Date()): {
  start: string;
  end: string;
} {
  const { startDate, endDate } = getLastYearToDateRange(today);
  return { start: startDate.toISOString(), end: endDate.toISOString() };
}

